import { BehaviorSubject, combineLatest, Subject } from "rxjs";
import { computed } from "../../../decorators/computed";

export class Contact$ {
  public fullName$: Subject<string> = new BehaviorSubject("");

  @computed
  get json$() {
    return combineLatest({
      fullName: this.fullName$,
    });
  }
}
